export default {
    LOAD_CATEGORY: 'loadCategory'
};